import { render } from "./ReceiptsListItem.vue?vue&type=template&id=748bea03"
import script from "./ReceiptsListItem.vue?vue&type=script&lang=js"
export * from "./ReceiptsListItem.vue?vue&type=script&lang=js"

import "./ReceiptsListItem.vue?vue&type=style&index=0&id=748bea03&lang=scss"
script.render = render

export default script